"use strict";

exports.__esModule = true;
exports.default = flatten;
var _getLength = _interopRequireDefault(require("./_getLength.js"));
var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));
var _isArray = _interopRequireDefault(require("./isArray.js"));
var _isArguments = _interopRequireDefault(require("./isArguments.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal implementation of a recursive `flatten` function.
function flatten(input, depth, strict, output) {
  output = output || [];
  if (!depth && depth !== 0) {
    depth = Infinity;
  } else if (depth <= 0) {
    return output.concat(input);
  }
  var idx = output.length;
  for (var i = 0, length = (0, _getLength.default)(input); i < length; i++) {
    var value = input[i];
    if ((0, _isArrayLike.default)(value) && ((0, _isArray.default)(value) || (0, _isArguments.default)(value))) {
      // Flatten current level of array or arguments object.
      if (depth > 1) {
        flatten(value, depth - 1, strict, output);
        idx = output.length;
      } else {
        var j = 0,
          len = value.length;
        while (j < len) output[idx++] = value[j++];
      }
    } else if (!strict) {
      output[idx++] = value;
    }
  }
  return output;
}